<template>
  <div class="ibox">
    <div class="ibox-title"><h5>吉宅管理</h5></div>
    <div class="ibox-content">
    <div class="crud-bar">
      <el-select v-model="status" placeholder="全部状态" clearable @change="fetch" style="width:160px">
        <el-option label="待处理(0)" value="0" />
        <el-option label="未分配(2)" value="2" />
        <el-option label="制作中(3)" value="3" />
        <el-option label="待审核(4)" value="4" />
        <el-option label="待评估(5)" value="5" />
        <el-option label="已完成(6)" value="6" />
      </el-select>
      <el-button icon="el-icon-refresh" @click="fetch">刷新</el-button>
    </div>
    <el-table :data="list" v-loading="loading" border stripe>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="name" label="姓名" width="110" />
      <el-table-column prop="tel" label="电话" width="130" />
      <el-table-column prop="area" label="区域" width="100" />
      <el-table-column prop="leixing" label="类型" width="100" />
      <el-table-column prop="fengge" label="风格" width="100" />
      <el-table-column label="状态" width="100">
        <template slot-scope="s"><el-tag>{{ statusText(s.row.status) }}</el-tag></template>
      </el-table-column>
      <el-table-column prop="adminId" label="负责人" width="80" />
      <el-table-column prop="createdAt" label="申请时间" width="170" />
      <el-table-column label="操作" width="200">
        <template slot-scope="s">
          <el-button size="mini" @click="openDetail(s.row)">详情</el-button>
          <el-button size="mini" type="primary" @click="onAssign(s.row)">分配</el-button>
          <el-button size="mini" type="success" @click="onComplete(s.row)">完成</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="吉宅订单详情" :visible.sync="detailVisible" width="520px">
      <pre class="detail-pre">{{ detailText }}</pre>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { jizhaisApi } from '../api/business'

const STATUS_MAP = { 0: '待处理', 2: '未分配', 3: '制作中', 4: '待审核', 5: '待评估', 6: '已完成' }

export default {
  name: 'AdminJizhais',
  data () {
    return {
      list: [],
      loading: false,
      status: '',
      detailVisible: false,
      detailText: ''
    }
  },
  created () { this.fetch() },
  methods: {
    statusText (s) { return STATUS_MAP[s] || s },
    async fetch () {
      this.loading = true
      try { this.list = await jizhaisApi.list(this.status) } catch (e) { this.$message.error(e.uiMessage || e.message) } finally { this.loading = false }
    },
    async openDetail (row) {
      try {
        const d = await jizhaisApi.detail(row.id)
        this.detailText = JSON.stringify(d, null, 2)
        this.detailVisible = true
      } catch (e) { this.$message.error(e.uiMessage || e.message) }
    },
    async onAssign (row) {
      const adminId = await this.$prompt('请输入负责人 admin_id', '分配订单', { inputValue: row.admin_id || '' })
        .then(r => r.value).catch(() => null)
      if (adminId === null) return
      try { await jizhaisApi.assign(row.id, Number(adminId)); this.$message.success('已分配'); this.fetch() } catch (e) { this.$message.error(e.uiMessage || e.message) }
    },
    async onComplete (row) {
      if (!await this.$confirm('确认标记为已完成？', '提示', { type: 'warning' }).catch(() => false)) return
      try { await jizhaisApi.complete(row.id); this.$message.success('已完成'); this.fetch() } catch (e) { this.$message.error(e.uiMessage || e.message) }
    }
  }
}
</script>

<style scoped>
.crud-bar { margin-bottom: 16px; display: flex; gap: 12px; }
.detail-pre { background: #f5f7fa; padding: 12px; border-radius: 4px; max-height: 400px; overflow: auto; }
</style>
